const actions = {
  ITEM_CATEGORY_ADD_BEGIN: 'ITEM_CATEGORY_ADD_BEGIN',
  ITEM_CATEGORY_ADD_SUCCESS: 'ITEM_CATEGORY_ADD_SUCCESS',
  ITEM_CATEGORY_ADD_ERR: 'ITEM_CATEGORY_ADD_ERR',
  
  ITEM_CATEGORIES_READ_BEGIN: 'ITEM_CATEGORIES_READ_BEGIN',
  ITEM_CATEGORIES_READ_SUCCESS: 'ITEM_CATEGORIES_READ_SUCCESS',
  ITEM_CATEGORIES_READ_ERR: 'ITEM_CATEGORIES_READ_ERR',

  ITEM_CATEGORY_UPDATE_BEGIN: 'ITEM_CATEGORY_UPDATE_BEGIN',
  ITEM_CATEGORY_UPDATE_SUCCESS: 'ITEM_CATEGORY_UPDATE_SUCCESS',
  ITEM_CATEGORY_UPDATE_ERR: 'ITEM_CATEGORY_UPDATE_ERR',

  ITEM_CATEGORY_DELETE_BEGIN: 'ITEM_CATEGORY_DELETE_BEGIN',
  ITEM_CATEGORY_DELETE_SUCCESS: 'ITEM_CATEGORY_DELETE_SUCCESS',
  ITEM_CATEGORY_DELETE_ERR: 'ITEM_CATEGORY_DELETE_ERR',

  ITEM_CATEGORY_READ_BEGIN: 'ITEM_CATEGORY_READ_BEGIN',
  ITEM_CATEGORY_READ_SUCCESS: 'ITEM_CATEGORY_READ_SUCCESS',
  ITEM_CATEGORY_READ_ERR: 'ITEM_CATEGORY_READ_ERR',

  ITEM_CATEGORY_UPLOAD_BEGIN: 'ITEM_CATEGORY_UPLOAD_BEGIN',
  ITEM_CATEGORY_UPLOAD_SUCCESS: 'ITEM_CATEGORY_UPLOAD_SUCCESS',
  ITEM_CATEGORY_UPLOAD_ERR: 'ITEM_CATEGORY_UPLOAD_ERR',

  axiosReadBegin: () => {
    return {
      type: actions.ITEM_CATEGORIES_READ_BEGIN,
    };
  },

  axiosReadSuccess: data => {
    return {
      type: actions.ITEM_CATEGORIES_READ_SUCCESS,
      data,
    };
  },

  axiosReadErr: err => {
    return {
      type: actions.ITEM_CATEGORIES_READ_ERR,
      err,
    };
  },

  axiosAddBegin: () => {
    return {
      type: actions.ITEM_CATEGORY_ADD_BEGIN,
    };
  },

  axiosAddSuccess: data => {
    return {
      type: actions.ITEM_CATEGORY_ADD_SUCCESS,
      data,
    };
  },

  axiosAddErr: err => {
    return {
      type: actions.ITEM_CATEGORY_ADD_ERR,
      err,
    };
  },

  // Update

  axiosUpdateBegin: () => {
    return {
      type: actions.ITEM_CATEGORY_UPDATE_BEGIN,
    };
  },

  axiosUpdateSuccess: data => {
    return {
      type: actions.ITEM_CATEGORY_UPDATE_SUCCESS,
      data,
    };
  },

  axiosUpdateErr: err => {
    return {
      type: actions.ITEM_CATEGORY_UPDATE_ERR,
      err,
    };
  },

  axiosDeleteBegin: () => {
    return {
      type: actions.ITEM_CATEGORY_DELETE_BEGIN,
    };
  },

  axiosDeleteSuccess: data => {
    return {
      type: actions.ITEM_CATEGORY_DELETE_SUCCESS,
      data,
    };
  },

  axiosDeleteErr: err => {
    return {
      type: actions.ITEM_CATEGORY_DELETE_ERR,
      err,
    };
  },

  axiosSingleDataBegin: () => {
    return {
      type: actions.ITEM_CATEGORY_READ_BEGIN,
    };
  },

  axiosSingleDataSuccess: data => {
    return {
      type: actions.ITEM_CATEGORY_READ_SUCCESS,
      data,
    };
  },

  axiosSingleDataErr: err => {
    return {
      type: actions.ITEM_CATEGORY_READ_ERR,
      err,
    };
  },

  axiosUploadBegin: () => {
    return {
      type: actions.ITEM_CATEGORY_UPLOAD_BEGIN,
    };
  },

  axiosUploadSuccess: data => {
    return {
      type: actions.ITEM_CATEGORY_UPLOAD_SUCCESS,
      data,
    };
  },

  axiosUploadErr: err => {
    return {
      type: actions.ITEM_CATEGORY_UPLOAD_ERR,
      err,
    };
  },

};

export default actions;
